<template>
    <transition name="fade">
        <div>
            <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-10">
                    <div class="alert alert-info2 text-justify">
                        <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>
                        <span class="text-justify fs-15">Only accepts <b>png, jpg, jpeg file format</b>. If you’re using a computer or a laptop, you may only upload an existing photo. If you’re using your mobile phone/tablet/IPAD, you may upload a government-issued ID with photo and signature.</span>
                    </div>
                    <div class="attachment-block clearfix" :style="{borderColor: $v.form.selfie.$error ? '#dc3545' : ''}">
                        <div class="text-center">
                            <img :src="fileURL" class="img-fluid" style="max-height: 300px;" v-if="form.selfie">
                            <img class="img-fluid" src="images/id-holder.jpg" style="max-height: 300px;" v-else>
                        </div>
                    </div>
                    <div class="text-center">
                        <p v-if="$v.form.selfie.$error" class="danger fs-14">Required</p>
                        <label class="btn btn-sm btn-primary nowrap pointer">
                            Browse/Capture
                            <input type="file" hidden accept=".png, .jpg, .jpeg" @change="onUpload">
                        </label>
                    </div>
                </div>
                <div class="col-sm-1"></div>
            </div>
            <div class="row">
                <div class="col-12">
                    <button class="btn btn-outline-primary" @click="$emit('next', 3)"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                    <button class="btn btn-primary float-right" @click="btnNext()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    // api
    import {
        apiRefGovID
    } from "@js/api/getReferences";
    import {
        required
    } from "vuelidate/lib/validators";

    export default {
        data() {
            return {
                form: {
                    borrower_id: null,
                    selfie: null,
                },
                fileURL: '',
                fileImage: ['image/jpeg', 'image/png', 'image/jpg', 'image/JPEG', 'image/PNG', 'image/JPG']
            }
        },

           validations() {
            return {
                form: {
                    selfie: {
                        required
                    },
                }
            }
        },
        created() {
            this.initData();
        },
        methods: {
            btnNext() {
                this.$v.form.$touch();
                if (this.$v.form.$invalid) {
                    const err = {
                        response: {
                            data: {
                                message: "Please complete all required fields",
                            }
                        }
                    };
                    this.$emit('error', err);
                } else {
                    this.postStep4();
                }
            },
            postStep4() {
                let formData = new FormData();
                formData.append('borrower_id', this.form.borrower_id);
                formData.append('photo', this.form.selfie);

                Fire.$emit('loader', 1)
                axios
                    .post("/api/sblaf-prereg-post-step4", formData)
                    .then(res => {
                        Fire.$emit('loader', -1)
                        this.$emit('next', 5);
                    })
                    .catch(err => {
                        this.$emit('error', err);
                        Fire.$emit('loader', -1)
                    });
            },

            async getStep4() {
                try {
                    const res = await axios.get("/api/sblaf-prereg-step4");
                    return res.data;
                } catch (err) {
                    throw err;
                }
            },
            async getImage(filename) {
                try {
                    const res = await axios.get("/api/v2-files", {
                        params: {
                            filename: filename
                        },
                        responseType: 'blob'
                    });
                    return res;
                } catch (err) {
                    throw err;
                }
            },
            async initData() {
                Fire.$emit('loader', 1);
                try {

                    this.form = await this.getStep4();

                    if (this.form.selfie) {
                        const res = await this.getImage(this.form.selfie);
                        if (res.status == 200) {
                            this.fileURL = window.URL.createObjectURL(res.data);
                        }
                        if (res.status == 204) {
                            this.form.selfie = '';
                        }
                    }
                    Fire.$emit('loader', -1);
                } catch (err) {
                    this.$emit('error', err);
                    Fire.$emit('loader', -1);
                }
            },

            invalidFileFormat() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Error',
                    text: 'You are uploading unsupported file format',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },

            onUpload($event) {
                let file = $event.target.files[0];
                if (file) {
                    if (this.fileImage.includes(file['type'])) {
                        this.form.selfie = file;
                        if (this.fileURL) {
                            window.URL.revokeObjectURL(this.fileURL);
                            this.fileURL = window.URL.createObjectURL(file);
                        } else {
                            this.fileURL = window.URL.createObjectURL(file);
                        }
                    } else {
                        this.invalidFileFormat();
                    }
                } else {}
            },
        },
    }
</script>